(() => {
  if (window.__CHS_CART_DRAWER_UPSELL_SCRIPT_LOADED__) return;
  window.__CHS_CART_DRAWER_UPSELL_SCRIPT_LOADED__ = true;

  class CartDrawerUpsellAddon {
    constructor(root = document) {
      this.root = root;
      this.handleClick = this.handleClick.bind(this);
      this.handleSelectChange = this.handleSelectChange.bind(this);
      this.bindEvents();
      this.syncCheckboxesFromCart();
    }

    bindEvents() {
      this.root.removeEventListener('click', this.handleClick);
      this.root.removeEventListener('change', this.handleSelectChange);

      this.root.addEventListener('click', this.handleClick);
      this.root.addEventListener('change', this.handleSelectChange);
    }

    isInsideUpsell(target) {
      return !!target.closest('.cart-drawer-upsell-addon');
    }

    getItemFromTarget(target) {
      return target.closest('.cart-drawer-upsell-addon__item[data-product-id]');
    }

    getVariantIdFromItem(item) {
      if (!item) return null;

      const select = item.querySelector('.variant-select');
      if (select && select.value) return Number(select.value);

      const hiddenInput = item.querySelector('.selected-variant-id');
      if (hiddenInput && hiddenInput.value) return Number(hiddenInput.value);

      return null;
    }

    ensureHiddenVariantInput(item) {
      let hiddenInput = item.querySelector('.selected-variant-id');

      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.className = 'selected-variant-id';
        item.appendChild(hiddenInput);
      }

      const select = item.querySelector('.variant-select');
      if (select && select.value) {
        hiddenInput.value = select.value;
      }

      return hiddenInput;
    }

    updateVariantVisuals(select) {
      const item = select.closest('[data-product-id]');
      if (!item) return;

      const selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) return;

      const priceWrap = item.querySelector('.option-price');

      if (priceWrap) {
        const price = selectedOption.dataset.price;
        const comparePrice = selectedOption.dataset.comparePrice;

        if (price) {
          const moneyFormat =
            window.theme?.moneyFormat ||
            window.Shopify?.money_format ||
            '${{amount}}';

          const money = Shopify.formatMoney(price, moneyFormat);

          if (comparePrice && Number(comparePrice) > Number(price)) {
            const compareMoney = Shopify.formatMoney(comparePrice, moneyFormat);
            priceWrap.innerHTML = `<span class="price-current">${money}</span><s class="price-compare">${compareMoney}</s>`;
          } else {
            priceWrap.innerHTML = `<span class="price-current">${money}</span>`;
          }
        }
      }

      this.ensureHiddenVariantInput(item).value = select.value;

      const imagesJson = item.querySelector('.variant-images-json');
      const imageTarget = item.querySelector('.cart-drawer-upsell-addon__image img');

      if (imagesJson && imageTarget) {
        try {
          const imagesMap = JSON.parse(imagesJson.textContent.trim() || '{}');
          const variantImage = imagesMap[select.value];

          if (variantImage?.url) {
            imageTarget.src = variantImage.url;
            imageTarget.alt = variantImage.alt || '';
          }
        } catch (error) {
          console.warn('Variant image map parse failed:', error);
        }
      }
    }

    async fetchCart() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`cart.js failed with status ${response.status}`);
      }

      return response.json();
    }

    async addVariantToCart(variantId) {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.description || data?.message || `cart/add.js failed with status ${response.status}`
        );
      }

      return data;
    }

    async removeVariantFromCart(variantId) {
      const cart = await this.fetchCart();
      const lineIndex = cart.items.findIndex(
        (cartItem) => Number(cartItem.variant_id) === Number(variantId)
      );

      if (lineIndex === -1) return;

      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: lineIndex + 1,
          quantity: 0
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.description || data?.message || `cart/change.js failed with status ${response.status}`
        );
      }

      return data;
    }

    async refreshDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        window.location.reload();
        return;
      }

      const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`, {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`cart drawer section fetch failed with status ${response.status}`);
      }

      const htmlText = await response.text();
      const parsed = new DOMParser().parseFromString(htmlText, 'text/html');
      const newCartDrawer = parsed.querySelector('cart-drawer');

      if (!newCartDrawer) {
        throw new Error('Updated cart-drawer element not found in section response');
      }

      cartDrawer.innerHTML = newCartDrawer.innerHTML;

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('active');
      }

      await this.syncCheckboxesFromCart();
    }

    async syncCheckboxesFromCart() {
      try {
        const cart = await this.fetchCart();

        document
          .querySelectorAll('.cart-drawer-upsell-addon [data-product-id]')
          .forEach((item) => {
            const checkbox = item.querySelector('.option-checkbox');
            if (!checkbox) return;

            const variantId = this.getVariantIdFromItem(item);
            checkbox.checked =
              !!variantId &&
              cart.items.some(
                (cartItem) => Number(cartItem.variant_id) === Number(variantId)
              );
          });
      } catch (error) {
        console.warn('Cart drawer upsell checkbox sync failed:', error);
      }
    }

    async handleClick(event) {
      if (!this.isInsideUpsell(event.target)) return;

      const select = event.target.closest('.variant-select');
      if (select) return;

      const item = this.getItemFromTarget(event.target);
      if (!item) return;

      const checkbox = item.querySelector('.option-checkbox');
      if (!checkbox) return;

      const clickedLabel = event.target.closest('.cart-drawer-upsell-addon__label');
      const clickedToggle = event.target.closest('.cart-drawer-upsell-addon__checkbox-ui');

      if (!clickedLabel && !clickedToggle) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (checkbox.dataset.busy === 'true') return;

      const variantId = this.getVariantIdFromItem(item);
      if (!variantId) return;

      checkbox.dataset.busy = 'true';
      checkbox.disabled = true;

      const willBeChecked = !checkbox.checked;
      checkbox.checked = willBeChecked;

      try {
        if (willBeChecked) {
          await this.addVariantToCart(variantId);
        } else {
          await this.removeVariantFromCart(variantId);
        }

        await this.refreshDrawer();
      } catch (error) {
        checkbox.checked = !willBeChecked;
        console.error('Cart drawer upsell toggle failed:', error);
      } finally {
        checkbox.dataset.busy = 'false';
        checkbox.disabled = false;
      }
    }

    handleSelectChange(event) {
      const select = event.target.closest('.cart-drawer-upsell-addon .variant-select');
      if (!select) return;

      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      this.updateVariantVisuals(select);
      const item = select.closest('[data-product-id]');
      if (item) {
        const checkbox = item.querySelector('.option-checkbox');
        if (checkbox) checkbox.checked = false;
      }
    }
  }

  window.CartDrawerUpsellAddon =
    window.CartDrawerUpsellAddon || new CartDrawerUpsellAddon(document);
})();